import script from "./SearchBySection.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchBySection.vue?vue&type=script&lang=ts&setup=true"

import "./SearchBySection.vue?vue&type=style&index=0&id=9076cd78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9076cd78"]])

export default __exports__